// extracted by mini-css-extract-plugin
module.exports = {"nav":"dnav_nav__wRjYG","row":"dnav_row__2HU6E","box":"dnav_box__1wp22"};